module.exports = __webpack_public_path__ + "media/images/illustrations/bg-shape-49213c49d98a197f3a4064b3acc297e0.png";